export default {
  name: 'Result',
  props: ['isSuccess', 'title', 'description']
};